import { ROUTES } from '@/routes/paths';

/** Ссылка на редактирование предложения (/app/sell/edit) — данные грузятся по orderId. */
export function makeSellEditUrl(orderId: number): string {
  return `${ROUTES.APP_SELL_EDIT}?orderId=${orderId}`;
}

/**
 * Ссылка на страницу предложения (/app/sell/offer). Только номер: всё остальное страница берёт из ответа сервера,
 * а адрес и название базиса в ссылке оседали бы в истории браузера и журналах сервера (у ИП название содержит ФИО).
 */
export function makeSellOfferUrl(orderId: number): string {
  return `${ROUTES.APP_SELL_OFFER}?orderId=${orderId}`;
}
